import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twMerge } from 'tailwind-merge'
import { DetailsTableDataGroup } from '../models'

export interface DataGroupBasicProps {
  isFirstGroup?: boolean
}

export function DataGroupBasic({
  labelClassName,
  label,
  valueClassName,
  value,
  isFirstGroup,
  icon,
  iconClassName,
}: DataGroupBasicProps & DetailsTableDataGroup) {
  return (
    <>
      <div
        data-testid="dataGroupBasic"
        className={twMerge(`text-[14px] leading-none`, !isFirstGroup ? 'pt-6' : '', labelClassName)}
      >
        {label}
      </div>
      <div className={twMerge(`flex pt-[10px] text-[14px] font-bold`, valueClassName)}>
        {icon ? (
          <FontAwesomeIcon data-testid="icon" icon={icon} className={twMerge('pr-2 text-xl', iconClassName)} />
        ) : (
          ''
        )}
        {value}
      </div>
    </>
  )
}
